import { http as atsHttp } from '@/lib/ats-https';

const submitScoreCard = async ({ applicationId, scorecardId, payload }) => {
  const response = await atsHttp.patch(
    `/ats_applications/${applicationId}/ats_scorecards/${scorecardId}`,
    payload
  );
  return response.data;
};

export { submitScoreCard };
